import * as React from "react";
const DocArrowSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={26}
    fill="none"
    {...props}
  >
    <path
      fill="#040919"
      d="M13 2.64A10.36 10.36 0 1 0 23.36 13 10.371 10.371 0 0 0 13 2.64Zm0 19.5A9.141 9.141 0 1 1 22.14 13 9.15 9.15 0 0 1 13 22.14Zm4.493-9.57a.61.61 0 0 1 0 .86l-3.25 3.25a.609.609 0 0 1-.861-.86l2.209-2.21H8.938a.61.61 0 1 1 0-1.22h6.653l-2.21-2.21a.609.609 0 0 1 .862-.86l3.25 3.25Z"
    />
  </svg>
);
export default DocArrowSVG;
